<div  class="searchAlign">
    <mat-form-field class="searchWidth">
        <input type="text" matInput placeholder="Search Applicant by Name" [formControl]="searchControl"><img class="ml-neg30px-important" src="../../../assets/svg/search.svg">
    </mat-form-field>
</div>
